export const projects = [
  {
    title: 'Anderson Pereira',
    description: 'Site de psicologia com apresentação do profissional, modalidades de atendimento e contato para agendamentos.',
    image: '/anderson-pereira.webp',
    imageWidth: 1900,
    imageHeight: 1079,
    demo: 'https://www.psicologoandersonpereira.com.br/',
    tags: ['Psicologia', 'Atendimento'],
    type: 'Psicologia',
  },
  {
    title: 'Talita Saldanha',
    description: 'Site de nutrição com apresentação da profissional, áreas de cuidado e acesso ao agendamento de consultas.',
    image: '/talita-saldanha.webp',
    imageWidth: 1901,
    imageHeight: 1079,
    demo: 'https://www.talitasaldanhanutri.com.br',
    tags: ['Nutrição', 'Agendamento'],
    type: 'Nutrição',
  },
  {
    title: 'Daniele Ferreira',
    description: 'Site profissional para apresentar a terapeuta, explicar a TRG e facilitar o contato para avaliações.',
    image: '/daniele-ferreira.webp',
    imageWidth: 1900,
    imageHeight: 1079,
    demo: 'https://www.danieleoliveira.com.br',
    tags: ['TRG', 'Atendimento'],
    type: 'Terapia',
  },
  {
    title: 'Tenda Fitness',
    description: 'Site institucional para apresentar a academia, suas modalidades, estrutura e localização.',
    image: '/tenda-fitness.webp',
    imageWidth: 1904,
    imageHeight: 1079,
    demo: 'https://tendafitness.codexa-service.workers.dev/',
    tags: ['Institucional', 'Fitness'],
    type: 'Academia',
  },
  {
    title: 'Sparta Suplementos',
    description: 'Catálogo de suplementos com fichas de produtos e comanda enviada pelo WhatsApp.',
    image: '/sparta-suplementos.webp',
    imageWidth: 1899,
    imageHeight: 1079,
    demo: 'https://spartasuplementos.pages.dev/',
    tags: ['Catálogo', 'WhatsApp'],
    type: 'Suplementos',
  },
  {
    title: 'New Collection',
    description: 'Loja virtual de moda com linguagem editorial, catálogo responsivo e foco em experiência de compra.',
    image: '/newcollection.webp?v=2',
    demo: 'https://newcollection.pages.dev/',
    tags: ['E-commerce', 'React'],
    type: 'Moda',
  },
  {
    title: 'Diamond iPhones',
    description: 'Vitrine digital premium para produtos Apple, localização e canais de atendimento.',
    image: '/diamondiphones.webp?v=2',
    demo: 'https://diamondiphones.pages.dev',
    tags: ['E-commerce', 'React'],
    type: 'Varejo',
  },
  {
    title: 'Codexa Dev',
    description: 'Presença digital para estúdio de tecnologia com foco em performance, serviços e posicionamento.',
    image: '/codexa.webp?v=2',
    demo: 'https://www.codexa.dev.br',
    tags: ['Next.js', 'Motion'],
    type: 'Studio',
  },
  {
    title: 'FR Advocacia',
    description: 'Site institucional com foco em autoridade jurídica, clareza e evolução para recursos de atendimento.',
    image: '/fr.webp?v=2',
    demo: 'https://www.roney.adv.br',
    tags: ['React', 'SEO'],
    type: 'Institucional',
  },
  {
    title: 'Urubu Ecoparque',
    description: 'Experiência digital imersiva para apresentar atrações, informações e a identidade do ecoparque.',
    image: '/urubu.webp?v=2',
    demo: 'https://urubuecoparque.pages.dev',
    tags: ['Full-Stack', 'API'],
    type: 'Experiência',
  },
  {
    title: 'Spansiva Tecnologia',
    description: 'E-commerce institucional para hardware e acessórios com navegação objetiva e visual técnico.',
    image: '/spansiva.webp?v=2',
    demo: 'https://spansiva.pages.dev',
    tags: ['E-commerce', 'React'],
    type: 'Tecnologia',
  },
];
